import Vue from 'vue'
import VueI18n from 'vue-i18n'
const path = require('path')
Vue.use(VueI18n)

 

const i18n = new VueI18n({
	locale: 'zh-cn',
  messages: (r => { 
      var langs={};
      var _langs= r.keys().map(function(key){
        var lean={};
        var index=key.substring(10,key.indexOf('/',11));
        var basename = path.basename(key, path.extname(key));
        lean[index]=r(key).default[basename];
        return  lean;
      });
      for(var i=0;i<_langs.length;i++){
        langs = Object.assign(langs, _langs[i]);
      }
      return langs;
  })(require.context('./', true, /^\.\/locales\/([\s\S])+\.langs\.js$/)), 
   silentTranslationWarn: true
});

export default i18n


// WEBPACK FOOTER //
// ./src/i18n/index.js